var map = {
	"./block_alux_connect_lite.js": "./src/playground/blocks/hardwareLite/block_alux_connect_lite.js",
	"./block_alux_nemo_lite.js": "./src/playground/blocks/hardwareLite/block_alux_nemo_lite.js",
	"./block_alux_teachnic_normal_lite.js": "./src/playground/blocks/hardwareLite/block_alux_teachnic_normal_lite.js",
	"./block_alux_teachnic_power_lite.js": "./src/playground/blocks/hardwareLite/block_alux_teachnic_power_lite.js",
	"./block_arduino_lite.js": "./src/playground/blocks/hardwareLite/block_arduino_lite.js",
	"./block_choco_lite.js": "./src/playground/blocks/hardwareLite/block_choco_lite.js",
	"./block_cocodron_controller_Lite.js": "./src/playground/blocks/hardwareLite/block_cocodron_controller_Lite.js",
	"./block_codewiz_lite.js": "./src/playground/blocks/hardwareLite/block_codewiz_lite.js",
	"./block_hamster_lite.js": "./src/playground/blocks/hardwareLite/block_hamster_lite.js",
	"./block_microbit2_lite.js": "./src/playground/blocks/hardwareLite/block_microbit2_lite.js",
	"./block_microbit2ble_lite.js": "./src/playground/blocks/hardwareLite/block_microbit2ble_lite.js",
	"./block_neo_cannon_lite.js": "./src/playground/blocks/hardwareLite/block_neo_cannon_lite.js",
	"./block_neo_lite.js": "./src/playground/blocks/hardwareLite/block_neo_lite.js",
	"./block_neo_spider_lite.js": "./src/playground/blocks/hardwareLite/block_neo_spider_lite.js",
	"./block_neobot_purple_lite.js": "./src/playground/blocks/hardwareLite/block_neobot_purple_lite.js",
	"./block_neobot_soco_lite.js": "./src/playground/blocks/hardwareLite/block_neobot_soco_lite.js",
	"./block_neobot_thinkcar_lite.js": "./src/playground/blocks/hardwareLite/block_neobot_thinkcar_lite.js",
	"./block_robolink_ZumiMini_lite.js": "./src/playground/blocks/hardwareLite/block_robolink_ZumiMini_lite.js",
	"./block_robotis_kkokdu_lite.js": "./src/playground/blocks/hardwareLite/block_robotis_kkokdu_lite.js",
	"./block_robotis_koalabot_lite.js": "./src/playground/blocks/hardwareLite/block_robotis_koalabot_lite.js",
	"./block_robotis_rgee_lite.js": "./src/playground/blocks/hardwareLite/block_robotis_rgee_lite.js",
	"./block_robotis_rla_lite.js": "./src/playground/blocks/hardwareLite/block_robotis_rla_lite.js",
	"./block_robotis_robotai_lite.js": "./src/playground/blocks/hardwareLite/block_robotis_robotai_lite.js",
	"./block_sensorboard_lite.js": "./src/playground/blocks/hardwareLite/block_sensorboard_lite.js",
	"./block_whalesbot_drone_lite.js": "./src/playground/blocks/hardwareLite/block_whalesbot_drone_lite.js",
	"./block_wizwing_controller_lite.js": "./src/playground/blocks/hardwareLite/block_wizwing_controller_lite.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/playground/blocks/hardwareLite sync ^(?%21.*index.js)((.*_lite\\.(js))*$)im";